import styled, { css } from 'styled-components'
import { ThemeSelectors, TypeMini, TypeSmart } from '@at/design-system-foundation'

export const StyledSearchFilterLocationCheckboxContainer = styled(TypeMini)`
    ${({ theme }) => {
        return css`
            .atds-field__checkbox {
                label {
                    color: inherit;
                    font-size: 14px;
                    align-items: center;
                }
                display: inline-block;
            }
            margin-bottom: 14px;
            margin-top: -7px;
            max-width: 100%;
            width: calc(100% - ${ThemeSelectors.getGridUnit(theme)});
            .atds-field__toggle {
                background-color: ${theme.color.bgSurface.default};
            }
        `
    }}
`
export const StyledSearchFilterSelectLabel = styled(TypeSmart)<{ $stackedLabel?: boolean }>`
    ${({ theme, $stackedLabel = false }) => {
        return css`
            background-color: transparent;
            color: ${ThemeSelectors.getCopyColor(theme)};
            font-size: 14px;
            display: ${$stackedLabel ? 'block' : 'inline-block'};
        `
    }}
`
